import React from "react";
import Popup from "../Popup/Popup";
import InputComponent from "../../components/DynamicInput/DynamicInput";
import "./EventDetailsPopup.css";

const EventDetailsPopup = ({ event, isVisible, onClose }) => {
  if (!event) return null;

  const startDate = new Date(event.start_date_time).toISOString().split("T")[0];
  const endDate = new Date(event.end_date_time).toISOString().split("T")[0];
  const startTime = new Date(event.start_date_time).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const endTime = new Date(event.end_date_time).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const formFields = [
    {
      label: "School Name",
      type: "text",
      value: event.school_name || "N/A",
      config: {
        label: "School Name",
        type: "text",
        placeholder: "Search school",
        required: true,
      },
    },
    // {
    //   label: "Event Type",
    //   type: "select",
    //   value: event.event_type || "",
    //   config: {
    //     label: "Event Type",
    //     type: "select",
    //     placeholder: "Select Event Type",
    //     required: true,
    //     options: [
    //       { label: "Academic", value: "ACADEMIC" },
    //       { label: "Extra Curricular", value: "EXTRA_CURRICULAR" },
    //     ],
    //   },
    // },
    {
      label: "Event Name",
      type: "select",
      value: event.name || "",
      config: {
        label: "Event Name",
        type: "select",
        placeholder: "Select Event",
        required: true,
        options: [{ label: event.name, value: event.name }],
      },
    },
    {
      label: "Event Level",
      type: "select",
      value: event.level || "",
      config: {
        label: "Event Level",
        type: "select",
        placeholder: "Select Level",
        required: true,
        options: [{ label: event.level, value: event.level }],
      },
    },
    {
      label: "Round",
      type: "select",
      value: event.round || "",
      config: {
        label: "Round",
        type: "select",
        placeholder: "Select Round",
        required: true,
        options: [{ label: event.round, value: event.round }],
      },
    },
    {
      label: "Grade",
      type: "select",
      value: event.grade || "",
      config: {
        label: "Grade",
        type: "select",
        placeholder: "Select Grade",
        required: true,
        options: [{ label: event.grade, value: event.grade }],
      },
    },
    {
      label: "Start Date",
      type: "date",
      value: startDate,
      config: { label: "Start Date", type: "date", required: true },
    },
    {
      label: "End Date",
      type: "date",
      value: endDate,
      config: { label: "End Date", type: "date", required: true },
    },
    {
      label: "Start Time",
      type: "time",
      value: startTime,
      config: { label: "Start Time", type: "time", required: true },
    },
    {
      label: "End Time",
      type: "time",
      value: endTime,
      config: { label: "End Time", type: "time", required: true },
    },
    {
      label: "Description",
      type: "textarea",
      value: event.description || "No description available",
      config: {
        label: "Description (optional)",
        type: "textarea",
        placeholder: "Description",
        required: false,
      },
    },
  ];
  const teamsFiels = [
    {
      label: "Senior Manager",
      type: "text",
      value: event.rep1 || "N/A",
      config: {
        label: "Senior Manager",
        type: "text",
        placeholder: "Senior Manager",
        required: true,
      },
    },
    {
      label: "Manager",
      type: "text",
      value: event.rep2 || "N/A",
      config: {
        label: " Manager",
        type: "text",
        placeholder: "Manager",
        required: true,
      },
    },
    {
      label: "EExecution Rep",
      type: "text",
      value: event.rep3 || "N/A",
      config: {
        label: "Execution Rep",
        type: "text",
        placeholder: "Execution Rep",
        required: true,
      },
    },
  ];
  return (
    <Popup
      isVisible={isVisible}
      onClose={onClose}
      title="Event Details"
      FirstBtnTitle="Close"
      SecondBtnTitle="OK"
      handelSecondry={onClose}
      handelPrimery={onClose}
      popupStyle={{ width: "720px" }}
    >
      <div className="createEvetnFormCont">
        {formFields.map((field, index) => (
          <InputComponent
            key={index}
            config={field.config}
            value={field.value}
            onChange={() => {}}
            disabled={true}
            options={{}}
          />
        ))}

        <div className="createEvetntoggleCont">
          <div className="toggleCont">
            <h4>Administrative control</h4>
            <div style={{ display: "flex", marginTop: "20px" }}>
              <p className="input-text-label">Is Paid Report?</p>
              <InputComponent
                config={{ type: "toggle" }}
                value={event.is_paid_report}
                onChange={() => {}}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="createEvetntoggleCont">
          <div className="toggleCont">
            <h4>Assign Team</h4>
            <div style={{ display: "flex", marginTop: "20px", gap: "20px" }}>
              {teamsFiels.map((field, index) => (
                <InputComponent
                  key={index}
                  config={field.config}
                  value={field.value}
                  onChange={() => {}}
                  disabled={true}
                  options={{}}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="createEvetntoggleCont">
          <div className="toggleCont">
            <h4>Event Mode</h4>
            <div style={{ display: "flex", marginTop: "20px", gap: "20px" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <input
                  type="radio"
                  id="offline"
                  name="eventtype"
                  value="OFFLINE"
                  checked={event.event_type === "OFFLINE"}
                  onChange={() => {}}
                  disabled
                />
                <label htmlFor="offline">Offline</label>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <input
                  type="radio"
                  id="online"
                  name="eventtype"
                  value="ONLINE"
                  checked={event.event_type === "ONLINE"}
                  onChange={() => {}}
                  disabled
                />
                <label htmlFor="online">Online</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default EventDetailsPopup;
